export default "__VITE_ASSET__$xUvrdWd__"